module.exports = __webpack_public_path__ + "media/images/landing_page/2023/tools/budget_en_mobile-53f2e58fa17d120736a56602b50ba66e.webp";